import React from 'react';
import { Trans } from '@lingui/react';
import { isMobileOnly } from 'react-device-detect';
import { Link } from 'react-router-dom';
import Footer from '../../../utils/footer/footer';
import vieweet from '../../../../images/vieweet-logo/vieweet-logo.svg';
import x from '../../../../images/vieweet-logo/x.svg';
import activateAccountIcon from '../../../../images/empty-states-illustrations/activate-your-account.svg';
import { reSendVerificationEmail } from '../../../../api-helper/api-auth';
import { defineMessage } from '@lingui/macro';
import { IMessage } from '../signup-partners';
import { ReactComponent as Apple } from '../../../../images/icons/apple.svg';
import { ReactComponent as PlayStore } from '../../../../images/icons/play-store.svg';

const googleDeepLink =
  'https://play.google.com/store/apps/details?id=com.vieweet.app&gl=GB&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1';
const appleDeepLink = 'https://apps.apple.com/gb/app/vieweet-360/id837173911';

interface IProps {
  email: string;
  logoUrl: string;
  setErrorMessage: (message: IMessage) => void;
  setDetailWrong: (state: boolean) => void;
}

const ActivateAccountPartner: React.FC<IProps> = ({ email, logoUrl, setErrorMessage, setDetailWrong }) => {
  const reSendEmail = async () => {
    try {
      await reSendVerificationEmail(email);
    } catch (error) {
      setErrorMessage(defineMessage({ message: 'There was an error sending email' }));
      setDetailWrong(true);
    }
  };

  if (isMobileOnly) {
    return (
      <div className='initial-pages-bg'>
        <div className='onboarding-content-layout'>
          <div className='sign-up-partners-logo'>
            <div>
              <img className='sign-up-partners-topbar-vieweet-logo' src={vieweet} alt='vieweet' />
            </div>
            <div>
              <img className='sign-up-partners-topbar-vieweet-logo' src={x} alt='x' />
            </div>
            <div>
              <img className='sign-up-partners-topbar-vieweet-logo' src={logoUrl} alt='x' />
            </div>
          </div>
          <div
            className='activate-account-initial-pages-container'
            style={{ padding: '40px 38px', width: '85%', height: '75%', transform: 'translate(-50%, -40%)' }}
          >
            <div className='activate-account-container-mobile'>
              <div data-testid='not-activated-text' className='title-activate-account-mobile'>
                You're almost there!
              </div>
              <div className='message-mobile'>Please activate your account using the link sent to your email.</div>
              <div className='message-mobile'>Once activated, download the Vieweet App and log in with your credentials.</div>
              <div className='button-section-mobile'>
                <div className='button-apple'>
                  <a className='link' href={appleDeepLink}>
                    <div className='content-button'>
                      <div>
                        <Apple />
                      </div>
                      <div className='text-button'>
                        <p className='sub'>Download on the </p>
                        <p className='main'>App Store</p>
                      </div>
                    </div>
                  </a>
                </div>
                <div className='button-google'>
                  <a className='link' href={googleDeepLink}>
                    <div className='content-button'>
                      <div>
                        <PlayStore />
                      </div>
                      <div className='text-button'>
                        <p className='sub'>GET IT ON </p>
                        <p className='main'>Google Play</p>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              <div className='message-mobile-bottom'>You can also access Vieweet via laptop or desktop computers on my.vieweet.com</div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className='initial-pages-bg'>
        <div className='onboarding-content-layout'>
          <div className='sign-up-partners-logo'>
            <div>
              <img className='sign-up-partners-topbar-vieweet-logo' src={vieweet} alt='vieweet' />
            </div>
            <div>
              <img className='sign-up-partners-topbar-vieweet-logo' src={x} alt='x' />
            </div>
            <div>
              <img className='sign-up-partners-topbar-vieweet-logo' src={logoUrl} alt='x' />
            </div>
          </div>
          <div />
          <div className='onboarding-topbar-links-section'>
            <div className='onboarding-topbar-link-no-border-below'>
              <Link to='/login'>
                <Trans id='Login' />
              </Link>
            </div>
            <div className='onboarding-topbar-link-border-below'>
              <h3>
                <Trans id='Sign up' />
              </h3>
            </div>
          </div>
          <div className='activate-account-initial-pages-container'>
            <img src={activateAccountIcon} alt='illustration' className='forget-password-img' />
            <div className='activate-account-container'>
              <React.Fragment>
                <div
                  data-testid='not-activated-text'
                  className='title-activate-account'
                  style={{ fontFamily: 'Poppins', fontWeight: '500', fontSize: '40px' }}
                >
                  <Trans id='Activate your account' />
                </div>
                <div className='message'>
                  <div className='sub-text-activate-account' style={{ color: '#000' }}>
                    <Trans id='We have sent an email to activate your account to:' />{' '}
                  </div>
                  <p className='name-activate-account' data-testid='email'>
                    {email}
                  </p>
                </div>
                <Link to='/login'>
                  <div className='a-ac-btn-container-link button-hover'>
                    <Trans id='Login' />
                  </div>
                </Link>
                <a
                  className='no-received-email'
                  href='/'
                  onClick={(e: React.MouseEvent): void => {
                    e.preventDefault();
                    reSendEmail();
                  }}
                >
                  <Trans id='Click here to resend' />
                </a>
              </React.Fragment>
            </div>
          </div>
        </div>
        <Footer isPublicRoute={true} />
      </div>
    );
  }
};

export default ActivateAccountPartner;
